var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningicon = function SvgWarningicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 14a1.042 1.042 0 1 0 0-2.083A1.042 1.042 0 0 0 9 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M9 9.833V6.5M7.476 2.383.893 13.87c-.672 1.172.174 2.63 1.524 2.63h13.165c1.35 0 2.196-1.458 1.524-2.63L10.524 2.383c-.675-1.177-2.373-1.177-3.048 0Z"
  })));
};
export default SvgWarningicon;